import { HStack } from '@chakra-ui/react';
import { headerLinks } from '../../constants/headerLink';
import { HeaderLink } from './HeaderLink';

export const LinkList = () => {
  return (
    <HStack gap={'20px'}>
      {headerLinks.map((link) => (
        <HeaderLink key={`${link.href}--${link.text}`} {...link} />
      ))}
    </HStack>
  );
};
